<template>
  <div>
    <OffersCriterasInfo
      v-if="item"
      :items="item.all_criteria"
      mode="row"
      :options="{tender: {show: false}, lot: { label: $t('Tenders.CriteriaToPosition')}}"/>
    <KeyValue
      :caption="$t('Tenders.AdditionalInfoPosition')"
      class="py-2"
      data-qa="additional-info"
      :value="item.additionalInfo || '–'"/>
  </div>
</template>
<script>
import KeyValue from 'components/common/KeyValue.vue'
import OffersCriterasInfo from 'components/tenders/tender page/offersGroups/OffersCriterasInfo.vue'

export default {
  name: 'offersParticipantGroupSubTableDetails',
  components: {
    KeyValue,
    OffersCriterasInfo
  },
  props: {
    item: {
      type: Object,
    },
  },
}
</script>
<style scoped lang="scss">
.criteria-list {
  display: grid;
  grid-template-columns: auto auto auto auto;
  gap: 5px;
}
</style>
